import apiClient from '../api/apiClient';

export const getProductsByOrgId = (orgId, params = {}) => {
  const queryParams = new URLSearchParams();
  
  // Ensure search parameter is properly handled, including when it's 0
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      // Special handling for search to ensure numeric values are properly sent
      if (key === 'search' && !isNaN(Number(params[key]))) {
        // For numeric searches, ensure it's sent as is (not converted to string)
        queryParams.append(key, params[key]);
      } else {
        queryParams.append(key, params[key]);
      }
    }
  });
  
  const queryString = queryParams.toString();
  const url = queryString ? `/products/org/${orgId}?${queryString}` : `/products/org/${orgId}`;
  
  return apiClient.get(url).then(response => response.data);
};

export const addProduct = (data) => {
  return apiClient.post('/products', data).then(response => response.data);
};

export const updateProduct = (orgId, productId, data) => {
  return apiClient.put(`/products/${orgId}/${productId}`, data).then(response => response.data);
};

export const deleteProduct = (orgId, productId) => {
  return apiClient.delete(`/products/${orgId}/${productId}`).then(response => response.data);
};

export const getProductById = (orgId, productId) => {
  return apiClient.get(`/products/${orgId}/${productId}`).then(response => response.data);
};

export const bulkCreateProducts = (data) => {
  return apiClient.post('/products/bulk', data).then(response => response.data);
};

export const deleteMultipleProducts = (productIds) => {
  return apiClient.post('/products/bulk-delete', { product_ids: productIds })
    .then(response => response.data);
};
